/* ==========================================================================
   Optimize Minerals — the SavedBy button, in our own button's clothes

   "Continue without protection" is drawn by the SavedBy app inside a shadow
   root on <savedby-checkout-plus>, and a shadow boundary is exactly what it
   sounds like: op-chrome.css cannot see past it. So the one control in the
   cart drawer that stayed a 30px pill in rgb(167, 92, 58) - an orange that is
   not the brand's - sat directly under a checkout button we had just put back
   on #D66234 with a 4px corner.

   The only way in is from the inside, so this puts one stylesheet into that
   shadow root. Two things make it safe enough to do:

   - Custom properties inherit THROUGH a shadow boundary, so the colours below
     are the same tokens every other button on the site reads. Nothing is
     hard-coded here that could drift from op-theme.css.
   - It is additive and idempotent. The app's own sheets are untouched, the
     style is marked and only ever added once per root, and if SavedBy renames
     the class or stops using a shadow root, the selector simply stops matching
     and their button comes back looking the way it did before.

   The declarations are `important` because the app ships its rules in
   adoptedStyleSheets, which are applied after anything appended here.
   ========================================================================== */

(function () {
  'use strict';

  var HOST = 'savedby-checkout-plus';
  var MARK = 'op-sb-style';

  /* The green version of our button: the same slate teal fill, warm white ink
     and --op-radius corner as the upsell's Add to cart a few rows above it. */
  var CSS = [
    '.sb__non-covered-link {',
    '  background-color: var(--op-slate-teal) !important;',
    '  border-color: var(--op-slate-teal) !important;',
    '  color: var(--op-warm-white) !important;',
    '  border-radius: var(--op-radius, 4px) !important;',
    '  font-family: var(--op-font-display) !important;',
    '  font-weight: 800 !important;',
    '  font-size: 14px !important;',
    '  letter-spacing: -0.01em !important;',
    '  text-transform: uppercase !important;',
    '  text-decoration: none !important;',
    '}',
    '.sb__non-covered-link:hover {',
    '  background-color: #0f2f31 !important;',
    '  border-color: #0f2f31 !important;',
    '}'
  ].join('\n');

  function paint(host) {
    var root = host.shadowRoot;
    if (!root || root.getElementById(MARK)) return;
    var style = document.createElement('style');
    style.id = MARK;
    style.textContent = CSS;
    root.appendChild(style);
  }

  function scan() {
    var hosts = document.getElementsByTagName(HOST);
    for (var i = 0; i < hosts.length; i++) paint(hosts[i]);
  }

  /* The drawer re-renders on every cart change and the app mounts itself some
     time after that, so the observer is what actually catches it - but a cart
     drawer redraws a lot, and painting on every mutation record would be work
     done dozens of times for one result. One pass per frame is plenty. */
  var queued = false;
  function queue() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () {
      queued = false;
      scan();
    });
  }

  scan();
  new MutationObserver(queue).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
  document.addEventListener('shopify:section:load', queue);
})();
